import axios from "axios";
import store from "../vuex/store";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

export default {
  async login(userNo, userPasswd) {
    const data = {
      userNo: userNo,
      userPasswd: userPasswd
    };

    try {
      //axios.defaults.headers.common["Authorization"] = "Bearer " + "fa8426a0-8eaf-4d22-8e13-7c1b16a9370c"; //JWTtoken;
      
      return await axios
        .post(`${store.state.host}/api/auth/login.do`, data, {
          headers: {
            //Authorization: "X-Access-Token",
            //"X-Auth-Token": "fa8426a0-8eaf-4d22-8e13-7c1b16a9370c"
            //"X-Access-Token": "fa8426a0-8eaf-4d22-8e13-7c1b16a9370c"
          }
        })
        .then(response => {
          return response;
        })
        .catch(error => {
          console.error("failed", error);
          alert("error::"+error);
        });
    } catch (err) {
      console.error(err);
    }

    return null;
  }
};
